var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareFriend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 55,
    viewBox: "0 0 255 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_569_9699)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 9,
    width: 174,
    height: 37,
    rx: 18.5,
    fill: "#157700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.722 21.1305L101.722 23.412L85.2631 23.412L85.2631 21.1305L92.1858 21.1305L92.1858 17.7373L94.6039 17.7373L94.6039 21.1305L101.722 21.1305ZM91.8153 31.6218L89.4362 32.2458C89.2997 30.2177 88.6172 27.0976 87.7592 24.7186L89.9822 24.1335C90.8988 26.5321 91.6203 29.5547 91.8153 31.6218ZM96.8074 32.8503L102.287 32.8503L102.287 35.1709L84.6391 35.1709L84.6391 32.8503L94.3504 32.8503C95.2279 30.4907 96.1639 26.8636 96.5734 24.0555L99.245 24.5431C98.5625 27.4096 97.646 30.5687 96.8074 32.8503ZM110.555 20.8184L107.357 20.8184L107.357 22.437L110.555 22.437L110.555 20.8184ZM107.357 26.0641L110.555 26.0641L110.555 24.4651L107.357 24.4651L107.357 26.0641ZM108.605 29.4962L110.477 28.6187C111.686 30.2567 112.973 32.4603 113.461 33.9619L111.413 34.9954C111.277 34.4884 111.043 33.9034 110.75 33.2793C108.547 33.9034 106.265 34.5274 104.491 35.0149L103.828 32.6358C104.218 32.5578 104.666 32.4603 105.134 32.3433L105.134 18.6734L112.7 18.6734L112.7 28.2092L107.357 28.2092L107.357 31.8363L109.697 31.2513C109.346 30.6468 108.976 30.0422 108.605 29.4962ZM121.32 18.6344L121.32 30.4127C121.32 31.5048 121.144 32.2653 120.442 32.6943C119.721 33.1233 118.804 33.1818 117.556 33.1818C117.478 32.4798 117.108 31.2903 116.757 30.6468C117.517 30.7053 118.317 30.6858 118.59 30.6858C118.843 30.6858 118.921 30.5883 118.921 30.3347L118.921 20.9744L116.152 20.9744L116.152 35.9119L113.792 35.9119L113.792 18.6344L121.32 18.6344ZM133.8 18.8489L136.082 17.9324C137.31 20.4089 139.748 23.2365 141.873 24.8746C141.249 25.3621 140.352 26.2981 139.904 26.9611C139.494 26.5906 139.085 26.1616 138.656 25.7131L138.656 25.8496C138.441 31.7388 138.207 34.0399 137.525 34.8589C137.037 35.4829 136.511 35.6779 135.75 35.7754C135.087 35.8729 133.956 35.8729 132.806 35.8339C132.767 35.1319 132.455 34.1569 132.045 33.4938C133.118 33.5718 134.132 33.5913 134.619 33.5913C134.97 33.5913 135.185 33.5523 135.399 33.3183C135.789 32.9088 136.004 31.1733 136.179 27.0976L132.338 27.0976C131.85 30.8418 130.583 34.1764 125.532 36.0679C125.239 35.4049 124.557 34.4494 123.991 33.9229C128.398 32.4993 129.412 29.9447 129.802 27.0976L126.507 27.0976L126.507 25.7326C126 26.2591 125.473 26.7271 124.947 27.1366C124.518 26.6101 123.523 25.6741 122.958 25.2646C125.395 23.6265 127.54 20.9354 128.71 17.9714L131.207 18.6929C130.251 20.9354 128.886 23.0805 127.345 24.8356L137.876 24.8356C136.335 23.0415 134.873 20.8964 133.8 18.8489ZM160.399 19.1609L160.399 21.111L143.453 21.111L143.453 19.1609L150.649 19.1609L150.649 17.7178L153.067 17.7178L153.067 19.1609L160.399 19.1609ZM148.016 23.568L148.016 24.6796L155.855 24.6796L155.855 23.568L148.016 23.568ZM158.312 26.2786L145.695 26.2786L145.695 21.9885L158.312 21.9885L158.312 26.2786ZM160.691 30.4322L160.691 32.4018L153.125 32.4018L153.125 33.8254C153.125 34.9759 152.794 35.4439 151.858 35.7169C150.961 35.9704 149.674 35.9704 147.977 35.9704C147.821 35.3659 147.49 34.6054 147.178 34.0594C148.309 34.1179 149.83 34.1179 150.161 34.1179C150.551 34.0984 150.668 34.0204 150.668 33.7278L150.668 32.4018L143.18 32.4018L143.18 30.4322L150.668 30.4322L150.668 29.6132L151.76 29.6132C152.404 29.3987 153.067 29.1452 153.671 28.8722L145.091 28.8722L145.091 27.0586L156.811 27.0586L157.337 26.9611L158.78 28.2287C157.454 29.0282 155.855 29.8082 154.159 30.4322L160.691 30.4322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.262 27.576L193.101 35.2322L192.004 34.2058L199.164 26.5496L200.262 27.576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.262 27.576L193.101 35.2322L192.004 34.2058L199.164 26.5496L200.262 27.576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.262 27.576L193.101 35.2322L192.004 34.2058L199.164 26.5496L200.262 27.576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.262 27.576L193.101 35.2322L192.004 34.2058L199.164 26.5496L200.262 27.576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.101 35.2322L192.845 35.5065L193.119 35.7631L193.376 35.4888L193.101 35.2322ZM200.262 27.576L200.536 27.8326L200.793 27.5582L200.518 27.3016L200.262 27.576ZM192.004 34.2058L191.73 33.9492L191.473 34.2236L191.747 34.4802L192.004 34.2058ZM199.164 26.5496L199.421 26.2752L199.146 26.0186L198.89 26.293L199.164 26.5496ZM193.376 35.4888L200.536 27.8326L199.987 27.3194L192.827 34.9756L193.376 35.4888ZM191.747 34.4802L192.845 35.5065L193.358 34.9578L192.26 33.9314L191.747 34.4802ZM198.89 26.293L191.73 33.9492L192.278 34.4624L199.439 26.8062L198.89 26.293ZM200.518 27.3016L199.421 26.2752L198.908 26.8239L200.005 27.8503L200.518 27.3016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.167 28.2961L192.007 20.6399L193.104 19.6135L200.265 27.2698L199.167 28.2961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.167 28.2961L192.007 20.6399L193.104 19.6135L200.265 27.2698L199.167 28.2961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.167 28.2961L192.007 20.6399L193.104 19.6135L200.265 27.2698L199.167 28.2961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.167 28.2961L192.007 20.6399L193.104 19.6135L200.265 27.2698L199.167 28.2961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.007 20.6399L191.75 20.3656L191.476 20.6222L191.732 20.8965L192.007 20.6399ZM199.167 28.2961L198.893 28.5527L199.149 28.8271L199.424 28.5705L199.167 28.2961ZM193.104 19.6135L193.379 19.357L193.122 19.0826L192.848 19.3392L193.104 19.6135ZM200.265 27.2698L200.521 27.5441L200.796 27.2875L200.539 27.0132L200.265 27.2698ZM191.732 20.8965L198.893 28.5527L199.442 28.0395L192.281 20.3833L191.732 20.8965ZM192.848 19.3392L191.75 20.3656L192.263 20.9143L193.361 19.8879L192.848 19.3392ZM200.539 27.0132L193.379 19.357L192.83 19.8701L199.99 27.5264L200.539 27.0132ZM199.424 28.5705L200.521 27.5441L200.008 26.9954L198.911 28.0218L199.424 28.5705Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_569_9699",
    x: -3.00523,
    y: 0,
    width: 261.01,
    height: 61.0105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.00523
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.50262
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_569_9699"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_569_9699",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareFriend);
export default __webpack_public_path__ + "static/media/shareFriend.010d362718cacb2b5730467650e91dd9.svg";
export { ForwardRef as ReactComponent };